import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import PTRPortal from './App';
import { Provider } from 'react-redux';
import store from './stores';
import { App } from 'antd';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App>
    <BrowserRouter>
      <React.StrictMode>
        <Provider store={store}>
          <PTRPortal />
        </Provider>
      </React.StrictMode>
    </BrowserRouter>
  </App>
);
